import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import BlankColumnContent from '../../../../components/common/blank-column-content';
import Text, { H4 } from '../../../../components/common/text';
import {
  Currency,
  ChangeIndicatedPercent,
  ChangeIndicatedNumber,
} from '../../../../components/common/number';
import { NO_DATA } from '../../../../constants';
import styles from './chart-header.styles';
import SimpleDate from '../../../../components/common/date';

class ChartHeader extends PureComponent {
  static propTypes = {
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    value: PropTypes.number,
    valueUnit: PropTypes.string,
    testID: PropTypes.string,
    valueLabel: PropTypes.string,
    dayChangeLabel: PropTypes.string,
  };

  static defaultProps = {
    testID: 'header',
    valueLabel: 'Security Price',
    dayChangeLabel: 'Price Change',
    priceDateLabel: 'Price Date'
  };

  renderValue() {
    const { value, valueUnit, valueLabel, messages } = this.props;
    const fractions = { maximumFractionDigits: 4, minimumFractionDigits: 4 };
    let valueText = messages['app.common.portfolio.fxRate'];

    if (valueLabel == valueText) {
      return(
        <div aria-label={value != null ? value : messages['app.common.nullValue']}>
          <Text>{value != null ? value : NO_DATA}</Text>
        </div>
      );
    }
    return (
      <Currency
        renderProps={{
          style: value == null ? styles.itemValueBlank : undefined,
          size: 'large',
          testID: 'value',
        }}
        value={value != null ? value : NO_DATA}
        currency={valueUnit}
        {...fractions}
      />
    );
  }

  renderDayChangeValue() {
    const { dayChange, dayChangePercentage } = this.props;

    if (dayChange == null || dayChangePercentage == null) {
      return <BlankColumnContent />;
    }

    return (
      <H4 style={styles.itemValue} testID="value">
        <ChangeIndicatedNumber
          value={dayChange}
          withPlusSign
        />
        &nbsp;
        <ChangeIndicatedPercent value={dayChangePercentage} withPlusSign>
          {
            (text, props) =>
              <Text {...props}>
                ({text})
              </Text>
          }
        </ChangeIndicatedPercent>
      </H4>
    );
  }
  // JIRA #2975, Remove the Price change
  render() {
    const {
      valueLabel,
      dayChangeLabel,
      testID,
      priceDateLabel,
      priceDateValue,
      messages,
    } = this.props;
    let displayLabel = messages['app.portfolio.assetDetails.security'];
    switch (valueLabel) {
      case "Account balance":
        displayLabel = messages['app.portfolio.assetDetails.accountBalance'];
        break;
      case "FX Forward Rate":
        displayLabel = messages['app.common.portfolio.fxRate'];
        break;
      default:
        displayLabel = messages['app.portfolio.assetDetails.security'];
        break;
    }
    return (
      <View style={styles.root} testID={testID}>
        <View style={styles.itemLeft} testID="balance-or-price">
          <Text style={styles.itemLabel} testID="label">{displayLabel}</Text>
          <Text style={[styles.itemLabel, styles.marginValue]} testID="label">{messages['app.portfolio.assetDetails.priceDate']}</Text>
        </View>
        <View style={styles.itemRight} testID="balance-or-price">
          {this.renderValue()}
          <View style={styles.marginValue}>
            <SimpleDate value={priceDateValue} />
          </View>
        </View>
        {/*
        <View style={styles.itemSeparator} />
        <View style={styles.itemRight} testID="day-change">
           // JIRA #2975, Remove the Price change
          <Text style={styles.itemLabel} testID="label">{dayChangeLabel}</Text>
          {this.renderDayChangeValue()}
        </View>
        */}
      </View>
    );
  }
}

export default ChartHeader;
